import { z } from 'zod';

export const ledgerAccountTypes = [
  'asset',
  'liability',
  'income',
  'expense',
] as const;
export const LedgerAccountTypeSchema = z.enum(ledgerAccountTypes);
export type LedgerAccountType = (typeof ledgerAccountTypes)[number];
